<script setup lang="ts">
import {onMounted, ref, computed} from "vue";
import BookingInputPickerMobile from "@/components/BookingComponent/mobile/BookingInputPickerMobile.vue";
import CustomModal from "@/components/CustomModal/CustomModal.vue";
import BookingSearchModal from "@/components/BookingComponent/mobile/BookingSearchModal.vue";
import BookingDestinationPicker from "@/components/BookingComponent/BookingDestinationPicker.vue";
import BookingCalendarPicker from "@/components/BookingComponent/BookingCalendarPicker.vue";
import BookingPassengerPicker from "@/components/BookingComponent/BookingPassengerPicker.vue";
import BookingCategoryPicker from "@/components/BookingComponent/BookingCategoryPicker.vue";
import {useHomepageStore} from "@/stores/homepageStore";

const homepageStore = useHomepageStore();
const showSearchPopup = ref(false);
const isGulet = computed(() => homepageStore.selections.category?.id === 21);
const canSelectSkipper = computed(() => {
  const category = homepageStore.selections.category;
  return category?.id != null && category.id !== 21;
});

function enableScroll() {
  const htmlSelector = document.querySelector('html');
  htmlSelector.style.overflow = 'scroll';
}

onMounted(() => {
  homepageStore.reset()
  homepageStore.getCategories()
})

console.log(homepageStore.selections.dates);
</script>

<template>
  <div class="bg-amber-accent-1" v-if="false">
    {{ homepageStore.selections }}
    {{homepageStore.categories}}
    {{homepageStore.current}}
    {{homepageStore.hasQuery}}
    {{homepageStore.canRecommend}}
  </div>

  <div :class="`desktop-booking-component w-full h-full flex relative ${homepageStore.hasQuery ? 'elevation-24' : ''}`"
       tabindex="0"
       @keydown.esc="homepageStore.current == 'none'">
    <div v-if="homepageStore.isOpen" @click="homepageStore.current = 'none'" class="backdrop"></div>
    <div
        :class="`min-h-24 w-full flex flex-row items-center flex-wrap ${!homepageStore.hasQuery && homepageStore.current !== 'destination' ? 'rounded-l-8xl' : 'rounded-tl-8xl'}
        ${!homepageStore.hasQuery && homepageStore.current !== 'date' ? 'rounded-r-8xl' : 'rounded-tr-8xl'} search-component bg-gradient-to-r from-gradients-ghostWhite to-gradients-aliceBlue`">
      <BookingDestinationPicker
          :tabindex="1"
          :class="`${homepageStore.hasQuery ? 'elevated' : ''} bg-gradient-to-r from-gradients-ghostWhite to-gradients-aliceBlue rounded-l-8xl`"
      />

      <BookingCalendarPicker
          :tabindex="2"
          :class="`${homepageStore.hasQuery ? 'elevated' : ''} bg-gradient-to-r from-gradients-ghostWhite to-gradients-aliceBlue rounded-r-8xl`"
          @open="homepageStore.open"
      />
      
      <div v-if="homepageStore.canSearch"
           :class="`flex w-full h-full bg-gradient-to-r from-gradients-ghostWhite to-gradients-aliceBlue
            ${homepageStore.current == 'none' || homepageStore.current != 'passenger' ? 'rounded-br-8xl' : ''}
            ${homepageStore.current == 'none' || homepageStore.current != 'boat' ? 'rounded-bl-8xl' : ''} `">

      <BookingCategoryPicker
          :tabindex="3"
          :class="`bg-gradient-to-r from-gradients-ghostWhite to-gradients-aliceBlue rounded-bl-8xl`"
      />

      <BookingPassengerPicker
                              :tabindex="4"
                              :canSelectSkipper="canSelectSkipper"
                              :isGulet="isGulet"
                              class="bg-gradient-to-r from-gradients-ghostWhite to-gradients-aliceBlue rounded-br-8xl"
                              @on-search="$router.push({ path: '/search', query: homepageStore.query }); homepageStore.reset()"
                              @on-recommend="$router.push({ path: '/recommendations', query: homepageStore.query}); homepageStore.reset()"
      />

      </div>
    </div>
  </div>

  <div class="container sm:hidden flex">
    <CustomModal :show="showSearchPopup" @close="showSearchPopup = false">
      <BookingSearchModal
          @close="enableScroll(); showSearchPopup = false"
          @on-search="enableScroll(); $router.push({ path: '/search', query: homepageStore.query }); homepageStore.reset()"
          @on-recommend="enableScroll(); $router.push({ path: '/recommendations', query: homepageStore.query}); homepageStore.reset()"
      />
    </CustomModal>
    <div class="w-full h-full flex relative cursor-pointer">
      <div class="w-full flex flex-row items-center flex-wrap ">
        <BookingInputPickerMobile @on-tile-click="showSearchPopup = true"
        />
      </div>
    </div>
  </div>

</template>

<style scoped>
.backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10;
}

.search-component {
  z-index: 10;
}

@media (max-width: 767px) {
  .desktop-booking-component {
    display: none;
  }
}
</style>
